<script>
const MAX_VISIBLE = 3;

export default {
    name: 'JobAssigneeAvatars',
    props: {
        assignees: {
            type: Array,
            default: () => []
        },
        users: {
            type: Array,
            default: () => []
        },
        size: {
            type: Number,
            default: 20
        }
    },
    computed: {
        visibleAssignees() {
            return this.assignees.slice(0, MAX_VISIBLE);
        },
        extraCount() {
            return Math.max(0, this.assignees.length - MAX_VISIBLE);
        },
        extraNames() {
            return this.assignees.slice(MAX_VISIBLE).map(this.getUserName).join(', ');
        }
    },
    methods: {
        getUserImage(userId) {
            const user = (this.users || []).find(u => u && u.id === userId);
            return (user && user.profileImageUrl) ? user.profileImageUrl : '/img/avatar.svg';
        },
        getUserName(userId) {
            const user = (this.users || []).find(u => u && u.id === userId);
            return (user && (user.name || user.email)) || 'Unknown user';
        }
    }
};
</script>

<template>
    <span v-if="assignees.length" class="assignee-avatars d-flex align-items-center flex-shrink-0">
        <img v-for="userId in visibleAssignees" :key="userId" v-b-tooltip.hover.top="getUserName(userId)"
            :src="getUserImage(userId)" :width="size" :height="size"
            class="assignee-avatar rounded-circle" :alt="getUserName(userId)">
        <span v-if="extraCount" v-b-tooltip.hover.top="extraNames"
            class="assignee-extra fw-semibold rounded-pill">+{{ extraCount }}</span>
    </span>
    <img v-else src="/img/users.svg" class="flex-shrink-0" width="14" alt="default-assignee">
</template>

<style scoped>
.assignee-avatar {
    object-fit: cover;
    border: 2px solid #fff;
    box-sizing: content-box;
}

.assignee-avatar + .assignee-avatar {
    margin-left: -8px;
}

.assignee-extra {
    margin-left: -4px;
    font-size: 10px;
    padding: 0 5px;
    line-height: 18px;
    color: #6c757d;
    background: #e9ecef;
    border: 2px solid #fff;
}
</style>
